import React, { useState, useEffect, useContext } from "react";
import PageHeader from "../Header/PageHeader";
import CustomFolderList from "../Components/CustomFolderList";
import { useHistory } from "react-router-dom";
import GridView from "../Components/GridView";
import Pagination from "../Components/Pagination/Pagination";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../Network/apiCallGateway";
import AddFolderModal from "../Components/Modal/AddFolderModal";
import {
  addFolderschema,
  sharefolderSchemaObj,
} from "../Validation/FolderValidation";
import { useFormik } from "formik";
import { DataContext } from "../context/DataContext";
import ConfirmModal from "../Components/Modal/ConfirmModal";
import ShareModal from "../Components/Modal/ShareModal";
function Folder() {
  const {
    setFolderDetails,
    setIsShared,
    setLoader,
    getFolderAccessList,
    adminViewUser,
    setBrudCrumb,
    setSidebarSelected,
  } = useContext(DataContext);
  const history = useHistory();

  const [addFolderModal, setAddFolderModal] = useState(false);
  const [fDetails, setFdetails] = useState({});
  const [folderEdit, setFolderEdit] = useState(false);
  const [folderId, setFolderId] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [viewType, setViewType] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [shareModal, setShareModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const confirmtoggle = () => setConfirmModal(!confirmModal);
  const addFoldertoggle = () => setAddFolderModal(!addFolderModal);
  const sharetoggle = () => setShareModal(!shareModal);
  const {
    isLoading,
    error,
    data: folderList,
    refetch,
  } = useQuery({
    queryKey: ["folderList"],
    queryFn: async () => {
      const res = await ApiCallGateway.folder.getAllFolders(
        currentPage,
        adminViewUser?._id || null
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });

  const folderFormik = useFormik({
    initialValues: {
      name: folderEdit ? fDetails?.name : "",
      description: folderEdit ? fDetails?.description : "",
      color: folderEdit ? fDetails?.color : "",
    },
    validationSchema: addFolderschema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log({ ...values, shareWith: selectedUsers });
      let res;
      if (folderEdit) {
        res = await ApiCallGateway.folder.updateFolderEnv(
          values,
          fDetails?._id
        );
      } else {
        res = await ApiCallGateway.folder.createFolderEnv(
          { ...values, shareWith: selectedUsers, defaultEnvs: true },
          false
        );
      }
      addFoldertoggle();
      refetch();
      // console.log(res);
    },
  });
  const shareFolderFormik = useFormik({
    initialValues: {
      folderId: "",
      shareWith: [],
      note: "",
    },
    validationSchema: sharefolderSchemaObj,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });
      for (const element of selectedUsers) {
        let a = {
          passwordFolderId: values.folderId,
          shareWith: element?._id,
          sharedEmail: element?.email,
          sharedName: element?.name,
          expiryDate: null,
          note: values.note,
          isNew: !element?._id,
        };
        data.push(a);
      }
      // console.log(data, "kkk");
      const res = await ApiCallGateway.folder.shareFolderEnv(
        data,
        false
      );
      // console.log(res);
      sharetoggle();
      resetForm();
    },
  });

  useEffect(() => {
    refetch();
    setIsShared(false);
    setSidebarSelected("allFolders");
  }, [currentPage, adminViewUser]);

  const deleteFolder = async (id) => {
    setLoader(true);
    const res = await ApiCallGateway.folder.deleteFolderEnv(id);
    // console.log(res);
    if (res?.status === 200) {
      confirmtoggle();
      refetch();
      setLoader(false);
    }
    setLoader(false);
  };

  const handleSelectUsers = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers((oldValue) => [...oldValue, user]);
    }
  };

  const removeSelectUsers = (user) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(selectedUsers.filter((u) => u !== user));
    }
  };

  return (
    <div>
      <PageHeader
        title={"All Folders"}
        importCSV={false}
        viewType={viewType}
        setViewType={(e) => setViewType(e)}
        splitIcon={false}
        folder={true}
        leftHeader={false}
        addFoldertoggle={() => {
          addFoldertoggle();
          setFolderEdit(false);
          folderFormik.resetForm();
          setSelectedUsers([]);
        }}
      />
      {viewType === "list" ? (
        <CustomFolderList
          onItem={(fdetails) => {
            history.push(`/env_subfolder/${fdetails?._id}`);
            setFolderDetails(fdetails);
          }}
          detailstoggle={(details) => {
            history.push(`/env_subfolder/${details?._id}`);
            setFolderDetails(details);
          }}
          addNotetoggle={(id) => {
            // addNotetoggle();
            // setpasswordId(id);
          }}
          sharetoggle={(item) => {
            sharetoggle();
            setFolderId(item._id);
            getFolderAccessList(item._id);
            shareFolderFormik.setFieldValue("folderId", item._id);
          }}
          confirmtoggle={(item) => {
            confirmtoggle();
            setFolderId(item?._id);
          }}
          edittoggle={(details) => {
            // console.log(details);
            setFdetails(details);
            setFolderEdit(true);
            addFoldertoggle();
          }}
          env_subfolder={false}
          data={folderList?.data}
        />
      ) : null}
      {viewType === "grid" ? (
        <GridView
          env_subfolder={false}
          data={folderList?.data}
          onItem={(fdetails) => {
            history.push(`/env_subfolder/${fdetails?._id}`);
            setFolderDetails(fdetails);
          }}
        />
      ) : null}
      <Pagination
        totalPost={folderList?.total}
        postsPerPage={12}
        setCurrentPage={(e) => setCurrentPage(e)}
        currentPage={currentPage}
      />
      <ShareModal
        isFolder={true}
        md={true}
        shareModal={shareModal}
        shareModaltoggle={sharetoggle}
        formik={shareFolderFormik}
        handleSelectUsers={(id) => handleSelectUsers(id)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
      />
      <AddFolderModal
        title={
          folderEdit
            ? "Edit Folder/Project"
            : " Create New Folder/Project"
        }
        addFolderModal={addFolderModal}
        addFoldertoggle={addFoldertoggle}
        isEdit={folderEdit}
        formik={folderFormik}
        handleSelectUsers={(id) => handleSelectUsers(id)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        confirmModaltoggle={confirmtoggle}
        passwordId={folderId}
        onProceed={(id) => deleteFolder(id)}
      />
    </div>
  );
}

export default Folder;
